
(function () {
  'use strict';

  let isSwitching = false;
  let requestNumber = 0;

  // Format FREE offer text inside product cards.
  function formatSeriesOfferBadges(container = document) {
    container.querySelectorAll(
      '.product-series-selector__offer > span'
    ).forEach((el) => {
      el.innerHTML = el.textContent.replace(/\bFREE\b/, 'FREE<br>');
    });
  }

  function initProductSeriesSelector() {
    const selector = document.querySelector(
      '[data-product-series-selector]'
    );

    if (!selector || selector.dataset.initialized === 'true') {
      return;
    }

    selector.dataset.initialized = 'true';

    // Format offer badges on initial page load.
    formatSeriesOfferBadges(selector);

    document.addEventListener('click', async function (event) {
      const card = event.target.closest('[data-series-product-card]');

      if (!card || isSwitching) return;

      const productUrl = card.dataset.productUrl;

      if (!productUrl || card.classList.contains('is-active')) {
        return;
      }

      event.preventDefault();

      const currentSection = document.querySelector(
        '.product-section[data-section-type="product"]'
      );

      if (!currentSection) {
        console.error('Current product section not found.');
        return;
      }

      const currentRequest = ++requestNumber;
      isSwitching = true;

      document.querySelector(
        '[data-product-series-selector]'
      )?.classList.add('is-loading');

      try {
        const url = new URL(productUrl, window.location.origin);

        // Request the product section as HTML.
        url.searchParams.delete('sections');
        url.searchParams.delete('view');
        url.searchParams.delete('sections_url');

        url.searchParams.set(
          'section_id',
          currentSection.dataset.sectionId
        );

        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html'
          }
        });

        if (!response.ok) {
          throw new Error(
            `Section request failed: ${response.status}`
          );
        }

        const html = await response.text();

        console.log(
          'Section response content type:',
          response.headers.get('content-type')
        );

        console.log(
          'Section HTML preview:',
          html.slice(0, 500)
        );

        if (currentRequest !== requestNumber) return;

        if (!html.trim()) {
          console.error('Shopify returned an empty response.');
          return;
        }

        const parsedDocument = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const newSection = parsedDocument.querySelector(
          '.product-section[data-section-type="product"]'
        );

        if (!newSection) {
          console.error(
            'Product section not found in returned HTML.',
            {
              productUrl,
              sectionId: currentSection.dataset.sectionId,
              htmlPreview: html.slice(0, 1000)
            }
          );
          return;
        }

        const themeSections = window.Shopify?.theme?.sections;

        if (
          !themeSections ||
          typeof themeSections.unload !== 'function' ||
          typeof themeSections.load !== 'function'
        ) {
          console.error(
            'Pipeline section initialization methods are unavailable.'
          );
          return;
        }

        // Unload the existing product section.
        themeSections.unload(currentSection);

        // Replace the current product section.
        currentSection.replaceWith(newSection);

        // Initialize the replacement product section.
        themeSections.load('product', newSection);

        // Format offer badges after the new HTML is inserted.
        const updatedSelector = newSection.querySelector(
          '[data-product-series-selector]'
        );

        if (updatedSelector) {
          formatSeriesOfferBadges(updatedSelector);
        }

        // Update the URL without a full-page reload.
        window.history.pushState({}, '', productUrl);

        // Update the page title.
        const title = parsedDocument.querySelector('title');

        if (title) {
          document.title = title.textContent;
        }

        window.scrollTo({
          top: newSection.getBoundingClientRect().top +
            window.scrollY - 30,
          behavior: 'smooth'
        });

      } catch (error) {
        console.error('Product series switch failed:', error);

      } finally {
        isSwitching = false;

        document.querySelector(
          '[data-product-series-selector]'
        )?.classList.remove('is-loading');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initProductSeriesSelector
    );
  } else {
    initProductSeriesSelector();
  }
})();